/**
 * Application configuration
 * Centralizes environment-specific settings
 */

export const API_BASE_URL = 
  process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'development' 
    ? 'http://localhost:8000' 
    : 'https://backend-frosty-log-8280.fly.dev');
